import MentoringHeader from './MentoringHeader.vue';

export default MentoringHeader;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/header/index.ts